var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentageStamp = function SvgPercentageStamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 118,
    fill: "none",
    viewBox: "0 0 117 118"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#632E38",
    d: "M115.808 59c0 1.661-2.362 3.212-2.502 4.84-.141 1.65 1.917 3.584 1.635 5.201-.281 1.64-2.87 2.743-3.293 4.327-.422 1.595 1.268 3.868.715 5.408-.563 1.552-3.304 2.196-3.997 3.682-.694 1.497.585 4.032-.239 5.452-.823 1.432-3.629 1.574-4.571 2.928-.943 1.355-.12 4.065-1.17 5.321-1.051 1.268-3.846.918-5.005 2.087-1.16 1.17-.813 3.977-2.07 5.048-1.245 1.06-3.943.229-5.275 1.18-1.333.94-1.485 3.78-2.904 4.611-1.408.819-3.921-.459-5.406.24-1.473.699-2.112 3.464-3.65 4.032-1.528.557-3.77-1.147-5.363-.721-1.57.426-2.676 3.037-4.29 3.321-1.592.284-3.51-1.792-5.157-1.65-1.614.142-3.152 2.524-4.799 2.524-1.646 0-3.185-2.382-4.799-2.524-1.636-.142-3.553 1.934-5.157 1.65-1.625-.284-2.719-2.895-4.29-3.321-1.581-.426-3.835 1.278-5.362.721-1.538-.568-2.178-3.333-3.65-4.032-1.485-.699-3.998.59-5.407-.24-1.419-.831-1.56-3.66-2.903-4.611s-4.03-.12-5.276-1.18c-1.257-1.06-.91-3.879-2.07-5.048-1.158-1.169-3.942-.82-5.004-2.087-1.05-1.256-.228-3.977-1.17-5.32-.932-1.344-3.748-1.497-4.572-2.929-.812-1.42.455-3.955-.238-5.452-.628-1.497-3.37-2.13-3.933-3.682-.552-1.54 1.138-3.802.715-5.408-.422-1.584-3.011-2.699-3.293-4.327-.282-1.606 1.777-3.54 1.636-5.2-.14-1.629-2.503-3.18-2.503-4.84 0-1.661 2.362-3.213 2.503-4.84.14-1.65-1.918-3.585-1.636-5.202.282-1.639 2.87-2.742 3.293-4.326.423-1.596-1.267-3.868-.715-5.409.564-1.551 3.305-2.196 3.998-3.682.693-1.497-.585-4.031.238-5.452.824-1.431 3.63-1.573 4.572-2.928s.12-4.064 1.17-5.32c1.05-1.268 3.846-.919 5.005-2.088 1.16-1.169.812-3.977 2.07-5.037 1.245-1.06 3.942-.229 5.275-1.18 1.332-.94 1.484-3.78 2.903-4.61 1.409-.82 3.922.459 5.406-.24 1.452-.678 2.08-3.442 3.618-4.01 1.528-.558 3.77 1.147 5.363.72 1.57-.425 2.676-3.037 4.29-3.32 1.592-.285 3.51 1.791 5.157 1.649 1.614-.142 3.152-2.524 4.799-2.524 1.646 0 3.185 2.382 4.799 2.524 1.636.142 3.553-1.934 5.157-1.65 1.625.284 2.719 2.896 4.29 3.322 1.581.426 3.835-1.279 5.362-.721 1.538.568 2.178 3.332 3.65 4.031 1.485.7 3.998-.59 5.407.24 1.419.831 1.56 3.66 2.903 4.611s4.03.12 5.276 1.18c1.257 1.06.91 3.88 2.07 5.048 1.158 1.17 3.942.82 4.993 2.087 1.051 1.257.228 3.977 1.17 5.32.932 1.345 3.749 1.498 4.572 2.93.812 1.42-.455 3.954.238 5.451.694 1.486 3.434 2.13 3.998 3.682.552 1.54-1.138 3.802-.715 5.409.422 1.584 3.011 2.698 3.293 4.326.282 1.606-1.777 3.54-1.636 5.2.119 1.596 2.481 3.148 2.481 4.808"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "M22.979 39.388c-1.452-.972-1.788-2.884-.629-4.643 1.149-1.737 3.023-2.185 4.485-1.213 1.441.962 1.81 2.917.661 4.655-1.159 1.759-3.076 2.163-4.517 1.201m3.033-4.6c-.91-.611-2.004-.393-2.676.623-.671 1.027-.444 2.13.466 2.743.91.611 2.015.404 2.698-.623.671-1.027.433-2.13-.488-2.742"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m35.848 28.67-1.008.961-3.488-3.234 2.036 4.6-1.05.994-4.334-2.36 2.958 3.66-.943.885-3.683-4.567 1.55-1.453 3.867 2.065-1.766-4.053 1.516-1.432z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 163,
    height: 164,
    x: -8,
    y: -41,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m90.195-40.642-97.87 65.03 64.196 98.424 97.872-65.03z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m35.268 22.189-1.17.777 3.202 4.908 1.17-.778z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m39.584 25.676-.509-1.049c.823.132 1.68.055 2.502-.35.726-.36 1.019-.753.813-1.18-.14-.305-.412-.382-1.116-.24l-1.072.263c-1.192.284-1.874-.022-2.232-.754-.444-.929.043-2 1.56-2.743.964-.47 1.755-.513 2.275-.437l.487 1.016c-.584-.098-1.364-.021-2.166.372-.758.371-1.04.765-.867 1.125.12.252.38.328.975.186l1.127-.273c1.213-.295 1.907-.055 2.297.754.498 1.027-.087 2.152-1.495 2.84-.889.448-1.81.59-2.579.47"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m49.054 17.536-1.929.58 1.344 4.512-1.333.404-1.343-4.501-1.961.59-.336-1.115 5.233-1.584z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m55.294 21.35-.672-1.312-2.48.339-.315 1.442-1.397.186 1.43-6.119 1.939-.262 2.936 5.528zm-2.947-1.924 1.831-.251-1.257-2.437z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m57.426 20.945.032-1.158c.206.207.52.415 1.051.426.618.01 1.051-.306 1.062-1.027l.097-3.791 1.398.032-.098 4.021c-.032 1.388-.92 2-2.156 1.967-.639-.011-1.148-.23-1.386-.47"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m66.851 22.169-.249-1.464-2.46-.448-.736 1.278-1.386-.251 3.228-5.376 1.928.35 1.116 6.173zm-2.22-2.743 1.82.328-.456-2.71z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m75.844 19.01 1.17.47-2.123 5.464-1.69-.667-.954-5.222-1.636 4.195-1.17-.47 2.124-5.463 1.776.71.91 5.081z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m80.645 27.217 2.762 2.054-.639.874-3.89-2.885 3.457-4.73 3.856 2.862-.639.885-2.74-2.032-.726.994 2.578 1.912-.596.82-2.578-1.913z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m90.665 31.467-1.397-1.453-3.359 3.267-.964-1.017 3.348-3.266-1.42-1.486.835-.809 3.791 3.955z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m90.07 34.275 2.816-1.89.77 1.169-2.796 1.88c-.769.513-.888 1.267-.379 2.042.51.765 1.246.94 2.004.426l2.795-1.879.77 1.17-2.817 1.89c-1.333.895-2.795.524-3.76-.93-.963-1.485-.736-2.982.597-3.878"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "M23.301 79.749c1.43-1.016 3.315-.634 4.518 1.092 1.191 1.705.92 3.639-.51 4.655-1.419 1.005-3.347.644-4.539-1.071-1.202-1.715-.888-3.671.531-4.676m3.153 4.523c.888-.634 1.094-1.737.39-2.742s-1.81-1.191-2.698-.558c-.899.634-1.105 1.749-.4 2.765.693 1.005 1.809 1.18 2.708.535"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m32.4 94.4-1.028-.94 2.881-3.78-4.355 2.447-1.083-.972 1.96-4.567-3.368 3.3-.954-.875 4.193-4.086 1.57 1.42-1.7 4.065 3.846-2.131 1.549 1.398z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 163,
    height: 163,
    x: -62,
    y: -25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.33-24.994-62.62 99.428 98.889 63.46 62.619-99.428z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m37.643 90.715-3.123 4.958 1.182.758 3.124-4.958z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m37.875 97.11.498-1.05c.412.722 1.008 1.355 1.842 1.749.726.35 1.213.328 1.42-.099.14-.305.032-.568-.51-1.027l-.877-.677c-.965-.765-1.16-1.486-.813-2.229.433-.929 1.57-1.213 3.098-.492.975.46 1.495 1.06 1.755 1.52l-.476 1.026c-.282-.524-.845-1.093-1.647-1.475-.77-.36-1.246-.328-1.408.022-.12.262-.011.503.465.885l.921.71c.986.765 1.235 1.475.856 2.284-.487 1.027-1.712 1.278-3.13.6-.922-.425-1.604-1.07-1.994-1.748"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m50.28 97.427-1.929-.569-1.31 4.524-1.333-.405 1.3-4.512-1.961-.58.314-1.114 5.243 1.53z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m54.634 102.791-.315-1.442-2.48-.328-.672 1.312-1.398-.186 2.958-5.54 1.94.252 1.418 6.107zm-2.362-2.633 1.83.241-.584-2.688z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m57.526 102.693-.022-1.158c.217.197.542.393 1.062.382.617-.01 1.029-.36 1.018-1.081l-.087-3.791 1.398-.033.097 4.02c.033 1.388-.823 2.044-2.058 2.076-.65.011-1.17-.185-1.408-.415"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m67.71 101.961-.726-1.289-2.47.437-.25 1.464-1.397.251 1.181-6.173 1.928-.338 3.164 5.397zm-3.023-1.792 1.82-.327-1.354-2.382z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m73.58 93.94 1.181-.425 1.993 5.517-1.7.623-4.139-3.278 1.528 4.229-1.192.437-1.993-5.518 1.798-.656 4.02 3.202z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "x",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m82.343 94.454 2.806-2 .617.897-3.943 2.808-3.358-4.786 3.91-2.797.629.885-2.773 1.989.704 1.005 2.61-1.868.586.83-2.611 1.868z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m87.761 84.971-1.43 1.431 3.283 3.344-.997.994-3.282-3.343-1.452 1.442-.813-.82 3.879-3.878z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "z",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEB6B2",
    d: "m90.372 85.354-2.763-1.978.802-1.147 2.73 1.956c.758.535 1.495.382 2.026-.372s.422-1.508-.325-2.043l-2.73-1.956.802-1.147 2.762 1.978c1.31.94 1.484 2.436.487 3.867-1.018 1.443-2.48 1.77-3.791.842"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117 0H0v118h117z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.313 50.03c0-6.665 3.824-10.347 8.72-10.347 5.471 0 8.32 4.774 8.32 10.521 0 6.665-3.878 10.292-8.775 10.292-5.525 0-8.266-4.72-8.266-10.467m32.445-9.943h3.359L44.155 78.262h-3.023zm-21.84 13.395c0-6.326-.574-11.385-2.621-11.385-1.138 0-1.593 1.727-1.593 4.545 0 7.135.574 11.494 2.622 11.494 1.137 0 1.592-1.835 1.592-4.654M60.633 67.85c0-6.665 3.824-10.347 8.72-10.347 5.471 0 8.32 4.774 8.32 10.522 0 6.664-3.878 10.292-8.775 10.292-5.525 0-8.265-4.71-8.265-10.467m10.605 3.452c0-6.326-.574-11.385-2.621-11.385-1.138 0-1.593 1.727-1.593 4.546 0 7.134.574 11.494 2.622 11.494 1.137 0 1.592-1.836 1.592-4.655"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h117v118H0z"
  })))));
};
export { SvgPercentageStamp as ReactComponent };